import { DestroyRef, inject, Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ErrorService } from '../error.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Debounce } from '@ngx-seatback/utils';

@Injectable({
  providedIn: 'root',
})
export class QueryParamService {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly errorHandler = inject(ErrorService);
  public queryParams: Params = {};

  constructor() {
    this.activatedRoute.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: params => {
        this.queryParams = { ...params };
      },
      error: error => {
        this.errorHandler.errorHandler(error);
      },
    });
  }

  setQueryParam(name: string, value: string) {
    const params = this.queryParams;
    if (!params[name] || params[name] !== value) {
      params[name] = value;
      this.setQueryParams(params);
    }
  }

  clearQueryParam(name: string) {
    delete this.queryParams[name];
    this.setQueryParams(this.queryParams);
  }

  @Debounce(200) // Debounce annotation to avoid multiple router calls even though only qp are added
  setQueryParams(params: Params) {
    this.router
      .navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { ...params },
        replaceUrl: true,
        // queryParamsHandling: 'merge',
        onSameUrlNavigation: 'ignore',
      })
      .catch(error => this.errorHandler.errorHandler(error));
  }

  getQueryParam(name: string) {
    return this.queryParams[name];
  }
}
